
import { Component, Vue } from "vue-property-decorator";
import BackgroundLoader from "@/components/Common/BackgroundLoader.vue";

@Component({
  components: {
    BackgroundLoader,
  },
})
export default class EquipoValores extends Vue {

  public frame_valores = "1_1_equipo_valores.svg";
  public texto =
    `INGENIERÍA HUMANA nace de la colaboración entre Ingenieros de Caminos, Ingenieros de Obras Públicas, Arquitectos, Arquitectos Técnicos, Ingenieros Industriales e Ingenieros Técnicos Agrícolas que acumulan años de experiencia en las distintas tipologías de Obras Civiles, Edificación e Instalaciones Industriales.
    <br/><br/>
    <span class="texto-rojo">VALORES</span>
    <br/><br/>
    Para INGENIERÍA HUMANA la mejora en cuanto a la CALIDAD en el desarrollo de cada encargo, <span class="texto-bold">superando las expectativas del proyecto</span> es nuestro principal valor, proporcionando al cliente una asistencia técnica para optimizar los procedimientos de ejecución, con objeto de conseguir la mayor calidad con <span class="texto-bold">soluciones técnicas brillantes</span> y que además supongan respecto al presupuesto de proyecto una mejora para el cliente.
    <br/><br/>
    Todos los profesionales de INGENIERÍA HUMANA, trabajan siguiendo un Plan de Aseguramiento de la Calidad, que permite garantizar nuestros estrictos estándares de calidad, siguiendo un PLAN DE GESTIÓN DE LA DOCUMENTACIÓN.
    <br/><br/>
    Esta importante esfuerzo continuo en la mejora y ASEGURAMIENTO DE LA CALIDAD de ejecución, nos convierte en un referente en el campo de ingeniería a nivel nacional.`;

  // beforeDestroy() {
  //   console.log("BEFORE DESTROY EquipoValores");
  //   console.log("store.to: " + this.$store.state.toRoute + " store.from: " + this.$store.state.fromRoute);
  // }


}

